import { date } from 'quasar'
import Vue from 'vue'

const state = {
    accept_terms_and_conditions: '',
    access_token: '',
    admin_left_menu: false,
    device_token: '',
    email: '',
    full_name: '',
    has_mandatory_surveys: false,
    id: '',
    id_user_client_country_selected: '',
    id_user_client_profile: '',
    id_user_client_selected: '',
    id_user_language_selected: '',
    is_superuser: false,
    left_menu: false,
    refresh_token: '',
    reload_content: false,
    right_menu: false,
    status: '',
    user_branches: [],
    user_change_password: false,
    redirect_url: {},
    user_client_module_items: [],
    user_clients: [],
    user_countries: [],
    user_firebase_document: '',
    user_firebase_document_ranking_areas: [],
    user_firebase_token: '',
    user_image: '',
    user_module_items: [],
    user_modules: [],
    user_reward_campaign: {},
    webservice_token: '',
    accept_cookies_policy: '',
    date_request_set_user_data:''
}

const actions = {
    SET_ACCESS_TOKEN(context, [access_token, refresh_token, user_firebase_token]) {
        context.commit('SAVE_ACCESS_TOKEN', [access_token, refresh_token, user_firebase_token])
    },

    SET_USER_TOKEN(context, [access_token]) {
        context.commit('SAVE_USER_TOKEN', [access_token])
    },

    SET_USER_DATA(context, [
        accept_terms_and_conditions,
        email,
        full_name,
        has_mandatory_surveys,
        id,
        id_user_campaign_selected,
        id_user_client_country_selected,
        id_user_client_profile,
        id_user_client_selected,
        id_user_language_selected,
        is_superuser,
        user_client_module_items,
        user_clients,
        user_firebase_document,
        user_firebase_document_ranking_areas,
        user_image,
        user_module_items,
        user_modules,
        user_reward_campaign,
        user_branches,
        user_campaigns,
        status,
        accept_cookies_policy
    ]) {
        context.commit('SAVE_USER_DATA', [
            accept_terms_and_conditions,
            email,
            full_name,
            has_mandatory_surveys,
            id,
            id_user_campaign_selected,
            id_user_client_country_selected,
            id_user_client_profile,
            id_user_client_selected,
            id_user_language_selected,
            is_superuser,
            user_client_module_items,
            user_clients,
            user_firebase_document,
            user_firebase_document_ranking_areas,
            user_image,
            user_module_items,
            user_modules,
            user_reward_campaign,
            user_branches,
            user_campaigns,
            status,
            accept_cookies_policy
        ])
    },

    SET_TERMS_AND_CONDITIONS(context, [accept_terms_and_conditions]) {
        context.commit('SAVE_TERMS_AND_CONDITIONS', [accept_terms_and_conditions])
    },

    SET_USER_IMAGE(context, [user_image]){
		context.commit('SAVE_USER_IMAGE', [user_image])
	},

	SET_USER_COUNTRIES(context, [user_countries]){
		context.commit('SAVE_USER_COUNTRIES', [user_countries])
	},

    SET_RELOAD_CONTENT(context, [reload_content]) {
        context.commit('SAVE_RELOAD_CONTENT', [reload_content])
    },

    SET_CLIENT(context, [id_user_client_selected]) {
        context.commit('SAVE_CLIENT', [id_user_client_selected])
    },

    SET_COUNTRY(context, [id_user_client_country_selected]) {
        context.commit('SAVE_COUNTRY', [id_user_client_country_selected])
    },

    SET_LANGUAGE(context, [id_user_language_selected]) {
        context.commit('SAVE_LANGUAGE', [parseInt(id_user_language_selected)])
    },

    SET_LEFT_MENU(context, [left_menu]) {
        context.commit('SAVE_LEFT_MENU', [left_menu])
    },

    SET_RIGHT_MENU(context, [right_menu]) {
        context.commit('SAVE_RIGHT_MENU', [right_menu])
    },

    SET_ADMIN_LEFT_MENU(context, [admin_left_menu]) {
        context.commit('SAVE_ADMIN_LEFT_MENU', [admin_left_menu])
    },

    SET_MANDATORY_SURVEYS(context, [has_mandatory_surveys]) {
        context.commit('SAVE_MANDATORY_SURVEYS', [has_mandatory_surveys])
    },

    SET_WEBSERVICE_TOKEN(context, [webservice_token]) {
        context.commit('SAVE_WEBSERVICE_TOKEN', [webservice_token])
    },

    SET_DEVICE_TOKEN(context, [device_token]) {
        context.commit('SAVE_DEVICE_TOKEN', [device_token])
    },

    SET_USER_CHANGE_PASSWORD(context, [user_change_password]) {
        context.commit('SAVE_USER_CHANGE_PASSWORD', [user_change_password])
    },

    SET_REDIRECT_URL(context, [redirect_url]) {
        context.commit('SAVE_REDIRECT_URL', [redirect_url])
    },

    SET_ID_USER_CAMPAIGN_SELECTED(context, [id_user_campaign_selected]) {
        context.commit('SAVE_ID_USER_CAMPAIGN_SELECTED', [id_user_campaign_selected])
    },

    SET_COOKIES_POLICY(context, [accept_cookies_policy]) {
        context.commit('SAVE_COOKIES_POLICY', [accept_cookies_policy])
    },

    SET_DATE_REQUEST_USER_DATA(context, [date]) {
        context.commit('SAVE_DATE_REQUEST_USER_DATA', [date])
    }
}

const mutations = {
    SAVE_ACCESS_TOKEN: (state, [access_token, refresh_token, user_firebase_token]) => {
        Vue.set(state, 'access_token', access_token)
        Vue.set(state, 'refresh_token', refresh_token)
        Vue.set(state, 'user_firebase_token', user_firebase_token)
    },

    SAVE_USER_TOKEN: (state, [access_token]) => {
        Vue.set(state, 'access_token', access_token)
    },

    SAVE_USER_DATA: (state, [
        accept_terms_and_conditions,
        email,
        full_name,
        has_mandatory_surveys,
        id,
        id_user_campaign_selected,
        id_user_client_country_selected,
        id_user_client_profile,
        id_user_client_selected,
        id_user_language_selected,
        is_superuser,
        user_client_module_items,
        user_clients,
        user_firebase_document,
        user_firebase_document_ranking_areas,
        user_image,
        user_module_items,
        user_modules,
        user_reward_campaign,
        user_branches,
        user_campaigns,
        status,
        accept_cookies_policy
    ]) => {
        Vue.set(state, 'accept_terms_and_conditions', accept_terms_and_conditions)
        Vue.set(state, 'email', email)
        Vue.set(state, 'full_name', full_name)
        Vue.set(state, 'has_mandatory_surveys', has_mandatory_surveys)
        Vue.set(state, 'id', id)
        Vue.set(state, 'id_user_campaign_selected', id_user_campaign_selected)
        Vue.set(state, 'id_user_client_country_selected', id_user_client_country_selected)
        Vue.set(state, 'id_user_client_profile', id_user_client_profile)
        Vue.set(state, 'id_user_client_selected', id_user_client_selected)
        Vue.set(state, 'id_user_language_selected', id_user_language_selected)
        Vue.set(state, 'is_superuser', is_superuser)
        Vue.set(state, 'user_client_module_items', user_client_module_items)
        Vue.set(state, 'user_clients', user_clients)
        Vue.set(state, 'user_firebase_document', user_firebase_document)
        Vue.set(state, 'user_firebase_document_ranking_areas', user_firebase_document_ranking_areas)
        Vue.set(state, 'user_image', user_image)
        Vue.set(state, 'user_module_items', user_module_items)
        Vue.set(state, 'user_modules', user_modules)
        Vue.set(state, 'user_reward_campaign', user_reward_campaign)
        Vue.set(state, 'user_branches', user_branches)
        Vue.set(state, 'user_campaigns', user_campaigns)
        Vue.set(state, 'status', status),
        Vue.set(state, 'accept_cookies_policy', accept_cookies_policy)
    },

	SAVE_USER_COUNTRIES: (state, [user_countries]) => {
		Vue.set(state, 'user_countries', user_countries)
    },

    SAVE_TERMS_AND_CONDITIONS: (state, [accept_terms_and_conditions]) => {
        Vue.set(state, 'accept_terms_and_conditions', accept_terms_and_conditions)
    },

    SAVE_USER_IMAGE: (state, [user_image]) => {
		Vue.set(state, 'user_image', user_image)
    },

    SAVE_RELOAD_CONTENT: (state, [reload_content]) => {
        Vue.set(state, 'reload_content', reload_content)
    },

    SAVE_CLIENT: (state, [id_user_client_selected]) => {
        Vue.set(state, 'id_user_client_selected', id_user_client_selected)
    },

    SAVE_COUNTRY: (state, [id_user_client_country_selected]) => {
        Vue.set(state, 'id_user_client_country_selected', id_user_client_country_selected)
    },

    SAVE_LANGUAGE: (state, [id_user_language_selected]) => {
        Vue.set(state, 'id_user_language_selected', id_user_language_selected)
    },

    SAVE_LEFT_MENU: (state, [left_menu]) => {
        Vue.set(state, 'left_menu', left_menu)
    },

    SAVE_RIGHT_MENU: (state, [right_menu]) => {
        Vue.set(state, 'right_menu', right_menu)
    },

    SAVE_ADMIN_LEFT_MENU: (state, [admin_left_menu]) => {
        Vue.set(state, 'admin_left_menu', admin_left_menu)
    },

    SAVE_MANDATORY_SURVEYS: (state, [has_mandatory_surveys]) => {
        Vue.set(state, 'has_mandatory_surveys', has_mandatory_surveys)
    },

    SAVE_WEBSERVICE_TOKEN: (state, [webservice_token]) => {
        Vue.set(state, 'webservice_token', webservice_token)
    },

    SAVE_DEVICE_TOKEN: (state, [device_token]) => {
        Vue.set(state, 'device_token', device_token)
    },

    SAVE_USER_CHANGE_PASSWORD: (state, [user_change_password]) => {
        Vue.set(state, 'user_change_password', user_change_password)
    },

    SAVE_REDIRECT_URL: (state, [redirect_url]) => {
        Vue.set(state, 'redirect_url', redirect_url)
    },

    SAVE_ID_USER_CAMPAIGN_SELECTED: (state, [id_user_campaign_selected]) => {
        Vue.set(state, 'id_user_campaign_selected', id_user_campaign_selected)
    },

    SAVE_COOKIES_POLICY: (state, [accept_cookies_policy]) => {
        Vue.set(state, 'accept_cookies_policy', accept_cookies_policy)
    },

    SAVE_DATE_REQUEST_USER_DATA: (state, [date]) => {
        Vue.set(state, 'date_request_set_user_data', date)
    },
}

const getters = {
    access_token: state => {
        return state.access_token
    },

    admin_left_menu: state => {
        return state.admin_left_menu
    },

    accept_terms_and_conditions: state => {
        return state.accept_terms_and_conditions
    },

    device_token: state => {
        return state.device_token
    },

    email: state => {
        return state.email
    },

    full_name: state => {
        return state.full_name
    },

    has_mandatory_surveys: state => {
        return state.has_mandatory_surveys
    },

    id: state => {
        return state.id
    },

    id_user_campaign_selected: state => {
        return state.id_user_campaign_selected
    },

    id_user_client_country_selected: state => {
        return state.id_user_client_country_selected
    },

    id_user_client_profile: state => {
        return state.id_user_client_profile
    },

    id_user_client_selected: state => {
        return state.id_user_client_selected
    },

    id_user_language_selected: state => {
        return state.id_user_language_selected
    },

    is_superuser: state => {
        return state.is_superuser
    },

    left_menu: state => {
        return state.left_menu
    },

    refresh_token: state => {
        return state.refresh_token
    },

    reload_content: state => {
        return state.reload_content
    },

    right_menu: state => {
        return state.right_menu
    },

    user_client_module_items: state => {
        return state.user_client_module_items
    },

    user_clients: state => {
        return state.user_clients.sort((a, b) => {
            return a.name.trim() === b.name.trim() ? 0 : a.name.trim() < b.name.trim() ? -1 : 1
        })
    },

    user_countries: state => {
        return state.user_countries
    },

    user_firebase_document: state => {
        return state.user_firebase_document
    },

    user_firebase_document_ranking_areas: state => {
        return state.user_firebase_document_ranking_areas
    },

    user_firebase_token: state => {
        return state.user_firebase_token
    },

    user_image: state => {
        return state.user_image
    },

    user_module_items: state => {
        return state.user_module_items
    },

    user_modules: state => {
        return state.user_modules
    },

    user_reward_campaign: state => {
        return state.user_reward_campaign
    },

    webservice_token: state => {
        return state.webservice_token
    },

    user_branches: state => {
        return state.user_branches
    },

    user_campaigns: state => {
        return state.user_campaigns
    },

    status: state => {
        return state.status
    },

    user_change_password: state => {
        return state.user_change_password
    },

    redirect_url: state => {
        return state.redirect_url
    },

    accept_cookies_policy: state => {
        return state.accept_cookies_policy
    }, 

    date_request_set_user_data: state => {
        return state.date_request_set_user_data
    }
}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}
